import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HeaderDrawerWrap } from "../styles/StyledComponents/HeaderDrawerWrap";
import assests from "../ui/assests";
import ArrowIcon from "../ui/icons/ArrowIcon";
import CloseIcon from "../ui/icons/CloseIcon";
import { IHeaderDrawerProps } from "../ui/interface";
import { navMenu } from "../ui/json/routes.mock";

export const HeaderDrawer = ({ closeDrawer }: IHeaderDrawerProps) => {
  const location = useLocation();
  const pathname = location.pathname;

  const [expandedId, setExpandedId] = useState<number | string | null>(null);

  useEffect(() => {
    navMenu.forEach((item, index) => {
      item.subMenuList?.forEach((sub) => {
        if (sub.route === pathname) {
          setExpandedId(index);
        }
      });
    });
  }, [pathname]);

  const handleToggle = (id: number | string) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  return (
    <HeaderDrawerWrap>
      <button onClick={closeDrawer} className="closeIcon">
        <CloseIcon />
      </button>

      <div className="drawerInner">
        <Link to="/" className="headerLogo">
          <img src={assests.logo} alt="logoImg" />
        </Link>

        <ul className="mobile_menu_inner">
          {navMenu?.map((item, index) => (
            <li
              key={index}
              className={`menu_accordion ${expandedId === index ? "expanded" : ""} ${
                pathname === item.route ? "active" : ""
              }`}
            >
              <Link to={item.route}>
                {item.list}
                {item.subMenuList?.length > 0 && (
                  <button
                    onClick={(e) => {
                      if (item.subMenuList?.length > 0) {
                        e.preventDefault();
                        handleToggle(index);
                      }
                    }}
                    className={`arrow ${expandedId === index ? "rotate" : ""}`}
                  >
                    <ArrowIcon />
                  </button>
                )}
              </Link>

              {item.subMenuList?.length > 0 && (
                <div className="menuBody">
                  <ul className="submenuUl">
                    {item.subMenuList.map((sub, subIndex) => (
                      <li
                        key={subIndex}
                        className={`submenuli ${
                          pathname === sub.route ? "active_subList" : ""
                        }`}
                      >
                        <Link to={sub.route}>{sub.list}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </HeaderDrawerWrap>
  );
};
